import { z } from 'zod';
import { MAX_UUID_ARRAY_LENGTH } from './max-uuid-array-length.js';
/** Shared body for optionalUuidArray and optionalClientGeneratedUuidArray -- only the per-element UUID check and cap differ. */
export function uuidArraySchema(invalidMessage, isValid, options = {}) {
    const { maxItems = MAX_UUID_ARRAY_LENGTH, tooManyMessage = 'Too many selections.' } = options;
    return z.array(z.string()).superRefine((values, context) => {
        if (values.length > maxItems) {
            context.addIssue({ code: 'custom', message: tooManyMessage, path: [] });
        }
        for (const [index, value] of values.entries()) {
            if (!isValid(value)) {
                context.addIssue({ code: 'custom', message: invalidMessage, path: [index] });
            }
        }
    });
}
//# sourceMappingURL=uuid-array-schema.js.map